module.exports = __webpack_public_path__ + "static/media/baner.1b133cbe.svg";